import React from 'react';
import classNames from 'classnames';
import styles from './LogoTextBlocks.module.scss';
import {
  Field,
  ImageField,
  NextImage,
  Placeholder,
  RichText,
  RichTextField,
  Text,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';

type FieldsItem = {
  id: string;
  fields: {
    image?: ImageField;
    title?: Field<string>;
    description?: RichTextField;
  };
};

type Fields = {
  title?: Field<string>;
  description?: Field<string>;
  items?: FieldsItem[];
};

type LogoTextBlocksProps = ComponentProps & {
  fields: Fields;
};

const LogoTextBlocks: React.FC<LogoTextBlocksProps> = ({ fields, rendering }) => {
  const { title, description, items = [] } = fields;

  return (
    <section id={rendering.uid} className="default-section-padding background-white link-change">
      <div className="container">
        {title?.value && <Text tag="h2" field={title} className="h2 mb-3" />}
        {description?.value && (
          <Text tag="p" field={description} className="body-large text-grey" />
        )}
        <div className="mt-5 mt-md-6 mt-lg-8">
          {items.map((item, index) => (
            <div key={item.id}>
              {index > 0 && <div className={styles.divider} />}
              <div className="row">
                <div className="col-6 col-md-4 col-lg-3">
                  <NextImage
                    field={item.fields.image}
                    width={0}
                    height={0}
                    className="w-100 h-auto"
                    sizes="
                        (max-width: 575px) 50vw,
                        (max-width: 767px) 240px,
                        (max-width: 991px) 210px,
                        270px
                    "
                  />
                </div>
                <div className="col-12 col-md-8 col-lg-9 mt-3 mt-md-0">
                  {item.fields.title?.value && (
                    <Text tag="h3" field={item.fields.title} className="h3" />
                  )}
                  <RichText
                    tag="div"
                    field={item.fields.description}
                    className={classNames('body-default text-grey', styles.abrdnWrapper, {
                      'mt-3': item.fields.title?.value,
                    })}
                  />
                  <div className={styles.abrdnWrapper}>
                    <div>
                      <Placeholder name={`abrdn-list-${index}`} rendering={rendering} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogoTextBlocks;
